import FormInputData from 'data/FormInput';

const FrequencySelectFields = (override) =>
  FormInputData({
    fieldtype: 'frequency',
    fieldname: JSON.stringify({ override }),
  });

export default FrequencySelectFields;
